/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-05 14:25:39
 * @Description: 
 */
import React from 'react';
import cx from 'classnames';
import "./index.scss";

// 58车服愿景
const ProspectData = [
    {
        name: "车辆指定检测",
        desc: "联合开发覆盖燃油车及新能源车的智能年检解决方案与设备",
    },
    {
        name: "专业维保合作",
        desc: "与头部出行（嘀嗒、滴滴）及养护平台（京东养车、途虎）深度合作，保障车辆维保品质",
    },
    {
        name: "事故车救援",
        desc: "提供专业事故车运输/救援，创新三电检测，有效防控救援风险",
    },
    {
        name: "闭环回收交易",
        desc: " 依托专业物流仓储，构建事故车辆及动力电池回收、评估、交易平台",
    },
    {
        name: "全品类配件供应链",
        desc: " 搭建车用零配件、油/电品、轮胎等一站式供应体系，满足用户需求",
    },
    {
        name: "场景化车主权益",
        desc: "基于项目场景与用户洞察，定制专属涉车服务及权益方案",
    },
];

// 平台核心亮点
const Highlights = [
    {
        name: "智能运营体系",
        desc: "透明工厂、动态定价、智能报价协同数字化运营",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/btl8pbie__w2304_h1760.png",
    },
    {
        name: "金融保险平台融合对接",
        desc: "深度融合保险与金融平台工具，提供生态级资源支撑与业务赋能",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/e1hfsk8q__w2368_h824.png",
    },
    {
        name: "差异化解决方案",
        desc: "输出高度场景导向，精准匹配客户需求的定制化服务方案",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/nu0qrnar__w2368_h824.png",
    },
];

const Index = () => {

    return (
        <div className="chefu-aboutUs">
            {/* banner */}
            <div className="chefu-aboutUs-banner">
                <div className="chefu-section-main">
                    <div className="chefu-aboutUs-banner-main">
                        <p className="chefu-aboutUs-banner-title">
                            车后服务生态定位
                        </p>
                        <p>
                            深度融合线上线下服务网络，打造多元化、定制化车辆保障及车后服务，构建多层级数字化车服平台
                        </p>
                    </div>
                </div>
            </div>

            {/* 58车服愿景 */}
            <div className="chefu-aboutUs-prospect">
                <div className="chefu-section-title">58车服愿景</div>
                <div className="chefu-section-main chefu-aboutUs-prospect-main">
                    <ul className="chefu-aboutUs-prospect-list">
                        {ProspectData.map((item, i) => (
                            <li
                                className={cx("chefu-aboutUs-prospect-item", {
                                    "chefu-aboutUs-prospect-item-left": i % 2 === 0,
                                    "chefu-aboutUs-prospect-item-right": i % 2 === 1,
                                })}
                                key={`chefu-aboutUs-prospect-item${i}`}
                            >
                                <div className="chefu-aboutUs-prospect-item-content">
                                    <p className="chefu-aboutUs-prospect-item-name">
                                        {item.name}
                                    </p>
                                    <p>{item.desc}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* 平台核心亮点 */}
            <div className="chefu-aboutUs-highlights">
                <div className="chefu-section-title">平台核心亮点</div>
                <div className="chefu-section-main chefu-aboutUs-highlights-main">
                    <div
                        className="chefu-aboutUs-highlights-first chefu-aboutUs-highlights-item"
                        style={{
                            backgroundImage: `url(${Highlights[0].image})`,
                        }}
                    >
                        <p className="chefu-aboutUs-highlights-item-title">
                            {Highlights[0].name}
                        </p>
                        <p>{Highlights[0].desc}</p>
                    </div>
                    <ul className="chefu-aboutUs-highlights-list">
                        {Highlights.slice(1).map((item, i) => (
                            <li
                                className="chefu-aboutUs-highlights-item"
                                key={`chefu-aboutUs-highlights-item${i}`}
                                style={{
                                    backgroundImage: `url(${item.image})`,
                                }}
                            >
                                <p className="chefu-aboutUs-highlights-item-title">
                                    {item.name}
                                </p>
                                <p>{item.desc}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

        </div>
    );
}

export default Index;